import { useEffect, useState } from 'react'
import { updateMap } from '@carto/kepler.gl/actions'
import GeocoderWidget from 'features/common/ui/GeocoderWidget'
import { useAppDispatch, useAppSelector } from 'app/state'
import { Credentials } from '@carto/react-api'
import { geocodeStreetPoint } from '@carto/react-widgets'
import { useSearchParams } from 'react-router-dom'
import useBuilderMode from 'features/builder/hooks/useBuilderMode'
import { BuilderSearchParam } from 'features/common/utils/searchParamsUtils'
import { setGeocoderSearchText } from 'features/builder/state/builderSlice'

// TODO: Import from @carto/react-redux@v2.3.10.
export type GeocoderResult = {
  latitude: number
  longitude: number
  passive?: boolean
}

// Additional options in @carto/react-widgets.
export type GeocoderRequest = { searchText: string }

export async function getGeocoderResult(
  credentials: Credentials,
  request: GeocoderRequest
): Promise<GeocoderResult | null> {
  return geocodeStreetPoint(credentials, request)
}

function BuilderGeocoderWidget() {
  const dispatch = useAppDispatch()
  const geocoderResult = useAppSelector((state) => state.carto.geocoderResult)
  const [searchParams] = useSearchParams()
  const { isSharedMapLocation } = useBuilderMode()
  const initialSearchText = (isSharedMapLocation && searchParams.get(BuilderSearchParam.SEARCH)) || ''
  const [searchText, setSearchText] = useState(initialSearchText)

  useEffect(() => {
    if (geocoderResult && !geocoderResult.passive) {
      dispatch(updateMap({ zoom: 10, latitude: geocoderResult.latitude, longitude: geocoderResult.longitude }))
    }
  }, [geocoderResult, dispatch])

  useEffect(() => {
    dispatch(setGeocoderSearchText(searchText))
  }, [searchText, dispatch])

  return <GeocoderWidget initialSearchText={initialSearchText} onChange={setSearchText} />
}

export default BuilderGeocoderWidget
